import {createContext} from 'react';

const LookAiPopupContext = createContext({});

export const lookAiPopupContextReducer = (state = {}, action) => {
  return {...state, ...action};
}

export default LookAiPopupContext;

